const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

export async function uploadRegistrationProfilePhoto(file, phone) {
  const formData = new FormData();
  formData.append('photo', file);
  formData.append('phone', String(phone).replace(/\D/g, '').slice(-10));
  const response = await fetch(`${API_BASE_URL}/api/auth/register/profile-photo`, {
    method: 'POST',
    body: formData,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || 'Profile photo upload failed');
  }
  return result.path;
}

export async function uploadUserProfilePhoto(file, token) {
  const formData = new FormData();
  formData.append('photo', file);
  const response = await fetch(`${API_BASE_URL}/api/auth/profile-photo`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || 'Profile photo upload failed');
  }
  return result.user;
}

/** Convert data URL from legacy local picker to File for upload. */
export async function dataUrlToFile(dataUrl, filename = 'profile.jpg') {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type || 'image/jpeg' });
}
